import { createContext, useContext } from 'react';

const PageContext = createContext({});

export const usePageContext = () => useContext(PageContext);

export default PageContext;
